import { JsonPipe, KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { KsBasis, KsFactorEvidence } from '../../core/kickstart/assessment-record.types';

/**
 * One line's basis, as the record holds it (FLOW-347 DOC-79 §3A; FLOW-348
 * DOC-80 §3 *In this case*). Shows the rule, the inputs, the assessment's own
 * ground quoted, and for the amount the reduction log, the cap that bound and
 * the bands — **every value as recorded; nothing is worked out here.** Where
 * the record holds nothing, it says so: *No basis recorded for this*.
 */
@Component({
  selector: 'app-basis-view',
  imports: [JsonPipe, KeyValuePipe],
  templateUrl: './basis-view.html',
  styleUrl: './basis-view.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasisViewComponent {
  readonly basis = input<KsBasis | null | undefined>(null);

  protected readonly recorded = computed(() => {
    const b = this.basis();
    if (!b) return null;
    const inputs = Object.entries(b.inputs ?? {});
    const empty = !b.rule && !inputs.length && b.ground == null && !b.reduction_log?.length;
    return empty ? null : { basis: b, inputs };
  });

  protected isQuoted(ground: KsBasis['ground']): ground is string {
    return typeof ground === 'string';
  }

  protected asEvidence(ground: KsBasis['ground']): KsFactorEvidence[] {
    return Array.isArray(ground) ? ground : [];
  }

  protected isPlain(value: unknown): boolean {
    return value === null || ['string', 'number', 'boolean'].includes(typeof value);
  }

  /** A record key in words — the key itself, unpunctuated; never a new label. */
  protected words(key: string): string {
    return key.replace(/_/g, ' ');
  }
}
